import AppApiUrl from "../../api/AppApiUrl";
import { getFetch } from "../../tools/fetch";
import AppConfig from "../../AppConfig";
import * as ACTIONTYPES from "../constants/actiontypes";
import { getVideoResolution } from "../selectors/selectors";
import { hideControls } from "./controls-visibility-actions";
import { setTextHeight, showUnavailablePopup, toggleTextPlayerTheme } from "./index";
import { changeViewMode } from "./mode-switcher-actions";
import { setAutoplay, startedWatch } from "./play-actions";

const {
  BOOK_TYPE_DEFAULT_MODES,
  BOOK_TYPES: {
    AUDIO,
    AUDIO_BOOK,
  },
} = AppConfig;

const persistApiKey = (apiKey, userKey) => ({
  type: ACTIONTYPES.PERSIST_API_KEY,
  apiKey,
  userKey,
});

const persistToken = (token) => ({
  type: ACTIONTYPES.PERSIST_TOKEN,
  token,
});

const startBookFetching = () => ({
  type: ACTIONTYPES.FETCH_BOOK_START,
});

const finishBookFetching = () => ({
  type: ACTIONTYPES.FETCH_BOOK_FINISH,
});

const addBook = bookData => ({
  type: ACTIONTYPES.ADD_BOOK,
  bookData,
});

const setParentSelector = selector => ({
  type: ACTIONTYPES.SET_PARENT_SELECTOR,
  selector,
});

// const addBookFrames = framesData => ({
//   type: ACTIONTYPES.ADD_BOOK_FRAMES,
//   framesData,
// });

const persistWidgetChannel = (widgetChannel) => (dispatch, getState) => {
  const state = getState();
  const isWidget = !!state.app.isWidget;

  if (isWidget) {
    dispatch({
      type: ACTIONTYPES.PERSIST_WIDGET_CHANNEL,
      widgetChannel,
    });
  }
};

export const isBookBought = (userKey) => async (dispatch, getState) => {
  const state = getState();
  const tokenUrl = AppApiUrl.getTokenUrl(state.app.apiKey, userKey);
  let res = {};
  try {
    const { data } = await getFetch(tokenUrl);
    let token = data.token;
    if (token) {
      //const guid = QueryString.parse(window.location.search).guid;
      const guid = state.book.bookInfo.GUID;
      const isBookBoughtUrl = AppApiUrl.getIsBookBoughtUrl(token, guid);
      res = await getFetch(isBookBoughtUrl);
    }

  } catch (error) {
    console.log(error);
  }
  return res.data.isBought;
};

export const authorize = (initData) => async (dispatch, getState) => {
  const state = getState();
  let apiKey = getState().app.apiKey;
  let userKey = getState().app.userKey;
  if (!apiKey) {
    //apiKey = QueryString.parse(window.location.search).apiKey;
    apiKey = initData.apiKey;
    //userKey = QueryString.parse(window.location.search).userKey;
    userKey = initData.userKey;
    dispatch(persistApiKey(apiKey, userKey));
  }
  if (!!initData.parentSelector) {
    dispatch(setParentSelector(initData.parentSelector));
  }

  dispatch(setAutoplay(!!initData.autoPlay));
  let token = getState().app.token;
  if (token === null) {
    const tokenUrl = AppApiUrl.getTokenUrl(apiKey, userKey);
    try {
      const { data } = await getFetch(tokenUrl);
      let token = data.token;
      if (token) {
        const videoResolution = getVideoResolution(state);
        //const guid = QueryString.parse(window.location.search).guid;
        const guid = initData.guid;
        const bookUrl = AppApiUrl.getBookInfoUrl({ guid: guid, resolution: videoResolution });

        dispatch(persistToken(token));
        dispatch(fetchBook(bookUrl));
      } else {
        dispatch(persistApiKey(null));
      }

    } catch (error) {
      console.log(error);
    }
  }
};

export const fetchBook = (url) => async (dispatch, getState) => {
  const state = getState();

  const token = state.app.token;


  if (!token) {
    return;
  }

  dispatch(startBookFetching());

  try {
    const { data } = await getFetch(url + "&token=" + token);
    dispatch(finishBookFetching());

    if (!data || !data.bookInfo) {
      dispatch(showUnavailablePopup());
      return;
    }

    if (data.bookInfo.colorTheme) dispatch(toggleTextPlayerTheme(data.bookInfo.colorTheme));
    if (data.bookInfo.defaultTextHeight) dispatch(setTextHeight(data.bookInfo.defaultTextHeight));
    let book;
    if ([AUDIO, AUDIO_BOOK].includes(data.bookInfo.type)) {
      book = extractAudioBookData(data);
    } else {
      book = extractBookData(data);
    }


    if (data.channelIds) {
      dispatch(persistWidgetChannel(data.channelIds[0]));
    }

    dispatch(addBook( book ));

    let bookType = data.bookInfo.type;
    if (BOOK_TYPE_DEFAULT_MODES[bookType] !=='video') {
      dispatch(changeViewMode(BOOK_TYPE_DEFAULT_MODES[bookType]));
      dispatch(hideControls());
    }

    if (state.videoPlayerState.autoplay || BOOK_TYPE_DEFAULT_MODES[bookType] ==='text') {
      dispatch(startedWatch(true));
    }

  } catch (error) {
    dispatch(finishBookFetching());
    dispatch(showUnavailablePopup());
  }
};

const extractAudioBookData = ({ files, ...rest }) => {
  const audioBookData = files.reduce((a, b) => {
    a[b.type] = [...a[b.type] || [], b];
    return a;
  }, {});

  Object.keys(audioBookData).forEach(key => {
    if (audioBookData[key].length === 1) {
      audioBookData[key] = audioBookData[key][0];
    }
  });

  return {
    ...audioBookData,
    framesTime: audioBookData.frame_stream_description.map(item => item.start),
    ...rest,
  };
};

const extractBookData = (data) => {
  const bookData = data.files.reduce((a, b) => {
    a[b.type] = [...a[b.type] || [], b];
    return a;
  }, {});


  Object.keys(bookData).forEach(key => {
    if (bookData[key].length === 1) {
      bookData[key] = bookData[key][0];
    } else {
      bookData[key] = bookData[key].reduce((a, b) => {
        a[b.frame_n] = b;
        return a;
      }, {});
    }
  });

  const newJpg = bookData.jpg
    ? Object.keys(bookData.jpg).reduce((newObj, key) => {
      newObj[+key + 1] = bookData.jpg[key];
      return newObj;
    }, {})
    : ({});

  let hasText = false;
  let newText = {};

  if (bookData.text) {
    newText = Object.keys(bookData.text).reduce((newObj, key) => {
      newObj[+key + 1] = bookData.text[key];
      if (!hasText && bookData.text[key] && bookData.text[key]["data"]) {
        hasText = true;
      }

      return newObj;
    }, {});
  } else {
    for (let i = 1; i <= data.bookInfo.framesCount; i++) {
      newText[i] = "";
    }
  }


  const newSmall = bookData.small
    ? Object.keys(bookData.small).reduce((newObj, key) => {
      newObj[+key + 1] = bookData.small[key];
      return newObj;
    }, {})
    : ({});

  bookData.cover_h.data = "";
  bookData.cover_h.frame_n = -1;
  bookData.jpg = { ...newJpg, 0: bookData.cover_h };
  bookData.text = { ...newText, 0: bookData.cover_h };
  bookData.small = { ...newSmall, 0: bookData.cover_h };
  bookData.isDemo = data.isDemo && !data.isFree;
  bookData.isFree = data.isFree ? data.isFree : false;
  bookData.isLogged = data.isLogged;
  bookData.hasText = hasText;
  bookData.demoButtonText = data.demoButtonText;
  bookData.demoButtonUrl = data.demoButtonUrl;
  bookData.encriptedImages = {};
  bookData.privateChannel = data.privateChannel;
  bookData.loginFrame = data.loginFrame;
  bookData.cover = data.cover;

  const bookInfo = data.bookInfo;
  return {
    ...bookData,
    bookInfo,
    framesTime: data.audioInfo,
  };
};




// WEBPACK FOOTER //
// ./src/store/actions/data-fetching-actions.js